import { useEffect, useState } from 'react';

const useIsScrolling = () => {
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    const updateMoving = () => {
      setIsScrolling(true);
    };

    const updateStatic = () => {
      setIsScrolling(false);
    };

    window.addEventListener('scroll', updateMoving);
    window.addEventListener('scrollend', updateStatic);
    updateMoving();
    updateStatic();
    return () => {
      window.removeEventListener('scroll', updateMoving);
      window.removeEventListener('scrollend', updateStatic);
    };
  }, []);

  return isScrolling;
};

export default useIsScrolling;
